module.exports = __webpack_public_path__ + "img/FrederickSanger.8c2313ea.jpg";